import PageTitle from '@/components/PageTitle';
import useProductsContext from '@hooks/useProductsContext';
import useConnectionContext from '@hooks/useConnectionContext';
import { useAuthContext } from '@hooks/useAuthContext';
import Skeleton from 'react-loading-skeleton';
import { merchantIDWhiteList } from '@/constants';
import OnTimeBanner from '@/pages/components/OnTimeBanner';
import request from '@/api';
import { useState, useEffect } from 'react';
import classes from './index.module.css';
import Content from './content';
import Banner from './Banner';

const TitlePart = () => (
  <div className={classes.header}>
    <PageTitle title="Dashboard" />
    <div className={classes.title_bar_wrapper}>
      <div className={classes.title_bar_range}>Data range: </div>
      <div className={classes.title_bar_tabs}>Last 6 months</div>
      <div className={classes.title_bar_desc}>
        Does not include data from the current UTC day
      </div>
    </div>
  </div>
);
export default function Dashboard() {
  const {
    productsGallery, galleryLoading, productsInvolved, involvedLoading,
  } = useProductsContext();
  const { merchantId, store: { info } = {} } = useConnectionContext();
  const [isShowSpecialBanner, setIsShowSpecialBanner] = useState(false);

  const { merchantName } = useAuthContext();
  const isSpecialMerchantID = merchantIDWhiteList.includes(merchantId);
  useEffect(() => {
    const getData = async () => {
      try {
        // 如果是白名单商户，则查询是否开启了GDD，没有的话，显示banner信息
        const { code, data: { quoteConfig = {} } = {} } = await request('query-merchant-gdd-configs', {
          method: 'POST',
          body: {
            adminDomain: info,
          },
        });

        if (code === 0 && !Object.keys(quoteConfig).length) {
          setIsShowSpecialBanner(true);
        }
      } catch (error) {
        console.log(error);
      }
    };
    // 只有先开通了bp 之后，才需要去查询是否开通了DG
    const isActiveDG = productsGallery.filter((item) => item.insuranceId === '4' && item.involvedStatus === 'active')?.length;

    if (merchantId && isSpecialMerchantID && isActiveDG) {
      getData();
    }
  }, [merchantId, productsGallery]);

  if (galleryLoading || involvedLoading) {
    return (
      <div className={classes.wrapper}>
        <div className={classes.title}>
          <Skeleton containerClassName={classes.title} style={{ height: '100%', width: '150PX' }} />
        </div>
        <div className={classes.title_bar_wrapper}>
          <div className={classes.title_bar_range}>
            <Skeleton containerClassName={classes.title} style={{ height: '100%', width: '80PX' }} />
          </div>
          <Skeleton containerClassName={classes.title} style={{ height: '100%', width: '150PX' }} />
          <div className={classes.title_bar_desc}>
            <Skeleton containerClassName={classes.title} style={{ height: '100%', width: '280PX' }} />
          </div>
        </div>
        <Content galleryLoading={galleryLoading} />
      </div>

    );
  }
  return (
    <div className={classes.wrapper}>
      {!productsInvolved?.length ? <Banner name={merchantName} />
        : (isShowSpecialBanner && <OnTimeBanner />)}
      <TitlePart />
      <Content productsGallery={productsGallery} galleryLoading={galleryLoading} />
    </div>
  );
}
